import React from "react";
import { ClassNameProps, Column, makeClassName, StyleProps } from "@hex-insights/core";
import { AcademicTerm, ClassYearDetailQuery, useStudentNamesDescriptionsAndImagesQuery } from "../../../../Utilities";
import { Body } from "./Body";
import { Header } from "./Header";
import styles from "./styles.module.css";

export { type HeaderProps as DetailViewHeaderProps } from "./Header";
export { type BodyProps as DetailViewBodyProps } from "./Body";

export type DetailViewProps = {
	classYear: ClassYearDetailQuery["classYear"];
	academicTerm: Pick<AcademicTerm, "id" | "name" | "startDate" | "endDate"> & {
		academicYear: Pick<AcademicTerm["academicYear"], "id" | "name">;
	};
} & Partial<ClassNameProps & StyleProps>;

export function DetailView({ classYear, academicTerm, className, style }: DetailViewProps) {
	const { loading: loadingStudents, data: studentsData } = useStudentNamesDescriptionsAndImagesQuery({
		variables: {
			filters: {
				graduationYearEQ: classYear.graduationYear,
				studentAcademicTermEnrollments: [
					{
						academicTerm: [{ academicYearIDEQ: academicTerm.academicYear.id }],
					},
				],
			},
		},
	});
	const students = React.useMemo(() => studentsData?.studentConnection.edges.map((e) => e.node), [studentsData]);

	return (
		<Column
			justify="spaced-start"
			verticalSpacing="1rem"
			className={makeClassName(styles["main-column"], className)}
			style={style}
		>
			<DetailView.Header classYear={classYear} />
			<DetailView.Body
				classYear={classYear}
				academicTerm={academicTerm}
				isLoadingStudents={loadingStudents}
				students={students}
			/>
		</Column>
	);
}

DetailView.Header = Header;
DetailView.Body = Body;
